import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import {
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Tooltip
} from '@material-ui/core';
import CustomInput from '../../../../../utils/redux-forms-custom-fields/CustomInput';

const HEADER_CONFIGS = [
  {
    id: 'rankUpper',
    label: 'Rank Upper',
    tooltip: 'Must Above 0, Range From 1 To 999.',
    placeholder: 'Rank Upper'
  },
  {
    id: 'rankLower', 
    label: 'Rank Lower',
    tooltip: 'Must Above 0, Range From 1 To 9999.',
    placeholder: 'Rank Lower'
  },
  {
    id: 'watchTime',
    label: 'Watch Time(minutes)',
    tooltip: 'Must Above 0, Range From 1 To 99999999.',
    placeholder: 'Watch Time(minutes)'
  },
  {
    id: 'prize',
    label: 'Prize($)',
    tooltip: 'Must Above 0, Range From 1 To 99999999.',
    placeholder: 'Prize'
  }
];

const StreamingRankTable = ({ fields, questForm, questStarted, isNew }) => {
  const showActionColumn = (!questStarted || isNew) && 
    (questForm?.values?.splitTiers?.length > 0 || questForm?.values?.rankTiers?.length > 1);

  const handleDelete = React.useCallback((index) => {
    if (window.confirm('Are you sure you want to remove this tier?')) {
      fields.remove(index);
    }
  }, [fields]);

  return (
    <>
      <TableHead>
        <TableRow>
          {HEADER_CONFIGS.map(({ label, tooltip }) => (
            <TableCell key={label} align="center">
              {label} &nbsp;
              <Tooltip title={tooltip} placement="top">
                <i className="fa fa-info-circle" />
              </Tooltip>
            </TableCell>
          ))}
          {showActionColumn && <TableCell align="center">Action</TableCell>}
        </TableRow>
      </TableHead>
      <TableBody>
        {fields.map((item, index) => (
          <TableRow key={index}>
            {HEADER_CONFIGS.map(({ id, placeholder }) => (
              <TableCell key={`${item}.${id}`}>
                <Field
                  name={`${item}.${id}`}
                  id={`${item}.${id}`}
                  type="text"
                  component={CustomInput}
                  placeholder={placeholder}
                  onlyNumbers="true"
                />
              </TableCell>
            ))}
            {showActionColumn && (
              <TableCell align="center">
                <div className="RepeaterWrapper__item__new">
                  <button
                    className="RepeaterWrapper__item-remove-new"
                    type="button"
                    onClick={() => handleDelete(index)}
                  >
                    Delete
                  </button>
                </div>
              </TableCell>
            )}
          </TableRow>
        ))}
      </TableBody>
    </>
  );
};

StreamingRankTable.propTypes = {
  fields: PropTypes.object.isRequired,
  questForm: PropTypes.object,
  questStarted: PropTypes.bool,
  isNew: PropTypes.bool
};

export default React.memo(StreamingRankTable);